import React from "react";
import { useNavigate } from "react-router-dom";

const CustomBreadcrumbs = ({ pathTitle, className }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  const breadCrumb = localStorage.getItem("COLOR_BREADCRUMB");

  return (
    <nav
      aria-label="breadcrumb"
      className={className ? className : "mb-2"}
      style={{ backgroundColor: breadCrumb }}
    >
       <ol
          className="px-2 py-2"
          style={{ marginBottom: "5px", listStyle: "none", paddingLeft: 0 }}
        >
          <li
            className="breadcrumb-item d-flex align-items-center justify-content-between w-100"
            style={{ fontSize: "16px" }}
          >
            {pathTitle}

            <button
              className="btn"
              style={{
                border: "1px solid #b0b0b0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
                backgroundColor: isHovered ? "#ff4136" : "",
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => navigate("/home")}
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  fontSize: "20px",
                  color: isHovered ? "#ffffff" : "#b0b0b0",
                  transition: "color 0.2s ease",
                }}
              />
            </button>
          </li>
        </ol>

    </nav>
  );
};

export default CustomBreadcrumbs;
